import '@eon/tokens/css';
import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initI18n } from '@eon/i18n';
import { bootstrapSession, configureApi } from '@eon/api-client';
import { App } from './App';
import { isLoginPath, loginPath } from './lib/paths';

initI18n('tr');
const baseURL = import.meta.env.VITE_API_BASE_URL ?? '/api';
configureApi({
  baseURL,
  onUnauthorized: () => {
    if (!isLoginPath()) {
      window.location.assign(loginPath());
    }
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

// Try to silently restore a session via the httpOnly refresh cookie before
// mounting the router. Without this a full page reload always lands on /login
// because the in-memory access token is gone.
void bootstrapSession(baseURL).finally(() => {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
